import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-interselect-icon',
  templateUrl: './design-interselect.component.html'
})
export class DesignInterselectComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
